export default "__VITE_ASSET__9f7e3f0f__"